import Config from "../../config/Config";
import {
  createArrayEntityFromObject,
  createQueryUrl,
  getEntity,
  getEntityPy,
} from "../../config/global";
import ErrorHandler from "./errorHandler";

const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const getCompany = (initial) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/admin/company/initial/${initial}`, {
        headers: {},
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};

export const getCompanyInitial = (code) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}katalis/search/open/company/code/${code}`, {
        headers: {},
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};
